import * as React from "react";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {formatDate} from "../../../../../format";
import {Icon} from "semantic-ui-react";


export function GrayLogStatus(props: React.PropsWithChildren<{previousResponse: any}>) {

    const [response, setResponse] = React.useState<any>(null)

    React.useEffect(() => {
        if(!props.previousResponse) {
            refresh()
        } else {
            setResponse(props.previousResponse)
        }
    }, []);

    React.useEffect(() => {
        if(!props.previousResponse) {
            refresh()
        } else {
            setResponse(props.previousResponse)
        }
    }, [props.previousResponse]);

    function refresh() {
        getGraylogDelay().then((response) => {
            setResponse(response)
        })
    }
    return <div style={{marginTop: "1.5em", marginBottom: "1.5em"}}>
        <h4><Icon name={"book"} /> GrayLogStatus</h4>

        {response && <div>
            <h4 style={{
                color: getGraylogConnectionColorByMilliseconds(response.delayInMs)
            }}>
                Graylog Delay : {response.delayInMs} milliseconds
            </h4>
            <p>last check {formatDate(response.lastCheck)}</p>
        </div>
        }
    </div>
}

export async function getGraylogDelay() {
    let auth = backend.withTokenAuthHeader(authentication.token)

    let response = await fetch("/internalMonitoring/graylogDelay", {
        method: 'GET',
        headers: {
            "Authorization": auth.headers.Authorization.toString()
        }
    })

    return await response.json()
}

export function getGraylogConnectionColorByMilliseconds(ms: number) {
    if (ms < 1500) {
        return "green"
    } else if (ms < 5000) {
        return "orange"
    } else {
        return "red"
    }
}